import appHeaderEn from "./locales/en.json";

export const APP_HEADER_NS = "newappheader" as const;

export const AppHeaderTranslations = {
  en: {
    [APP_HEADER_NS]: {
      ...appHeaderEn,
    },
  },
};
